import React from 'react'
import Link from '../atoms/Link'
import SbEditable from 'storyblok-react'
import Richtext from '../atoms/Richtext'
import Headline from '../atoms/Headline'
import WidgetEmbed from '../technical/WidgetEmbed'
import { useTranslation } from 'react-i18next'

const DateListingBlock = ({ block }) => {
  const { t } = useTranslation()

  return (
    <SbEditable content={block}>
      <section className="date-listing-block">
        <div className="date-listing-block-container">
          <div className="date-listing-block-wrapper">
            <Headline headline={block.headline} />
            <Richtext text={block.text} />
          </div>
        </div>
        <ul className="date-listing-block-list">
          {block.date_listing_items?.length > 0 &&
            block.date_listing_items.map((item, index) => (
              <div
                className="date-listing-block-list-item"
                key={'item-' + index}
              >
                <div className="date-listing-block-container">
                  <div className="date-listing-block-list-item-content">
                    <div className="date-listing-block-list-item-date">
                      <div className="date-listing-block-list-item-date-bg">
                        <div className="date-listing-block-list-item-date-day">
                          {item.date_day}
                        </div>
                        <div className="date-listing-block-list-item-date-month">
                          {item.date_month}
                        </div>
                      </div>
                    </div>
                    <div className="date-listing-block-list-item-infos">
                      <div className="date-listing-block-list-item-text">
                        <div className="date-listing-block-list-item-title">
                          {item.name}
                        </div>
                        {item.description?.length > 0 && (
                          <div className="date-listing-block-list-item-description">
                            {item.description}
                          </div>
                        )}
                        <div className="date-listing-block-list-item-metainfos">
                          {item.time?.length > 0 && (
                            <span>
                              <span className="hide-mobile">
                                {t('date_listing.time')}:{' '}
                              </span>
                              {item.time}
                            </span>
                          )}
                          {item.place?.length > 0 && (
                            <span>
                              <span className="hide-mobile">
                                {t('date_listing.location')}:{' '}
                              </span>
                              {item.place}
                            </span>
                          )}
                          {item.speaker?.length > 0 && (
                            <span>
                              <span className="hide-mobile">
                                {t('date_listing.speaker')}:{' '}
                              </span>
                              {item.speaker}
                            </span>
                          )}
                          {item.category?.length > 0 && (
                            <span>{item.category}</span>
                          )}
                        </div>
                      </div>
                      <div className="date-listing-block-list-item-cta">
                        {item.booked_up ? (
                          <div className="date-listing-block-list-item-cta-booked-up">
                            {t('date_listing.booked_up')}
                          </div>
                        ) : (
                          <>
                            {item.code?.length > 0 ? (
                              <WidgetEmbed widgetHtml={item.code} />
                            ) : item.link_text?.length > 0 ? (
                              <Link link={item.link}>{item.link_text}</Link>
                            ) : (
                              <></>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </ul>
        {block.disclaimer?.length > 0 && (
          <div className="date-listing-block-container">
            <div className="date-listing-block-wrapper">{block.disclaimer}</div>
          </div>
        )}
      </section>
    </SbEditable>
  )
}

export default DateListingBlock
